import { atom } from 'recoil';

export const isNewVendorModalOpenAtom = atom<boolean>({
  key: 'isNewVendorModalOpenState',
  default: false,
});
